import BreadcrumbNav from "./BreadcrumbNav";

export default function OverlappingCard({ title }: { title: string }) {
  return (
    <div className="w-[80%] max-w-6xl mx-auto bg-white shadow-2xl rounded-2xl px-8 md:px-14 py-6 md:py-8 text-left -mt-[8vh] relative z-10 border border-gray-100 backdrop-blur-sm">
      <BreadcrumbNav className="mb-4" />
      <h1 className="text-2xl md:text-4xl font-bold break-words bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent relative">
        {title}
      </h1>
    </div>
  );
}
